import routeConfig from 'routes/config';
import type { SidebarSection, UserType } from './types';

export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const SIDEBAR_EXPANDED_WIDTH = 256;

export const partnerSections: SidebarSection[] = [
  {
    id: 'partner-main',
    items: [
      {
        id: 'stores',
        name: 'Stores',
        path: routeConfig.PARTNER_STORES.stores.path,
        layout: routeConfig.PARTNER_STORES.layout,
        icon: 'store',
      },
      {
        id: 'transactions',
        name: 'Transactions',
        path: routeConfig.PARTNER_TRANSACTIONS.transactions.path,
        layout: routeConfig.PARTNER_TRANSACTIONS.layout,
        icon: 'dollar-sign',
      },
      {
        id: 'marketplace',
        name: 'Marketplace',
        path: routeConfig.MARKETPLACE.marketplace.path,
        layout: routeConfig.MARKETPLACE.layout,
        icon: 'store',
      },
    ],
  },
  {
    id: 'partner-account',
    showDivider: true,
    items: [
      {
        id: 'settings',
        name: 'Settings',
        path: routeConfig.SETTINGS.ORGANISATION.path,
        layout: routeConfig.SETTINGS.layout,
        icon: 'settings',
      },
      {
        id: 'developers',
        name: 'Developers',
        path: routeConfig.DEVELOPERS.API_KEYS.path,
        layout: routeConfig.DEVELOPERS.layout,
        icon: 'code',
        children: [
          {
            id: 'api-keys',
            name: 'API Keys',
            path: routeConfig.DEVELOPERS.API_KEYS.path,
            layout: routeConfig.DEVELOPERS.layout,
            icon: 'lock',
          },
          {
            id: 'documentation',
            name: 'Documentation',
            path: routeConfig.DEVELOPERS.DOCUMENTATION.path,
            external: true,
            icon: 'help-circle',
          },
        ],
      },
    ],
  },
];

export const dispensarySections: SidebarSection[] = [
  {
    id: 'non-ach-main',
    items: [
      {
        id: 'analytics',
        name: 'Analytics',
        path: routeConfig.ANALYTICS.HOME.path,
        layout: routeConfig.ANALYTICS.layout,
        icon: 'home',
      },
    ],
  },
  {
    id: 'non-ach-payments',
    items: [
      {
        id: 'payments',
        name: 'Payments',
        path: routeConfig.PAYMENTS.transactions.path,
        layout: routeConfig.PAYMENTS.layout,
        icon: 'dollar-sign',
        children: [
          {
            id: 'transactions',
            name: 'Transactions',
            path: routeConfig.PAYMENTS.transactions.path,
            layout: routeConfig.PAYMENTS.layout,
            search: '?tab=summary',
            icon: 'transactions',
          },
          {
            id: 'tips',
            name: 'Tips',
            path: routeConfig.PAYMENTS.tips.path,
            layout: routeConfig.PAYMENTS.layout,
            search: '?tab=summary',
            icon: 'hand-coins',
          },
        ],
      },
    ],
  },
  {
    id: 'non-ach-store-features',
    hideAtOrgLevel: true,
    items: [
      {
        id: 'marketplace',
        name: 'Marketplace',
        path: routeConfig.MARKETPLACE.marketplace.path,
        layout: routeConfig.MARKETPLACE.layout,
        icon: 'store',
      },
      {
        id: 'application-center',
        name: 'Application Center',
        path: routeConfig.APPLICATION_CENTER.document_management.path,
        layout: routeConfig.APPLICATION_CENTER.layout,
        icon: 'edit',
        children: [
          {
            id: 'document-management',
            name: 'Document Management',
            path: routeConfig.APPLICATION_CENTER.document_management.path,
            layout: routeConfig.APPLICATION_CENTER.layout,
            icon: 'upload',
          },
          {
            id: 'one-app',
            name: 'One App',
            path: routeConfig.APPLICATION_CENTER.one_app.path,
            external: true,
            icon: 'one-app',
          },
        ],
      },
      {
        id: 'virtual-terminal',
        name: 'Virtual Terminal',
        path: routeConfig.VIRTUAL_TERMINALS.checkout.path,
        layout: routeConfig.VIRTUAL_TERMINALS.layout,
        icon: 'calculator',
      },
    ],
  },
  {
    id: 'non-ach-account',
    hideAtOrgLevel: true,
    items: [
      {
        id: 'settings',
        name: 'Settings',
        path: routeConfig.SETTINGS.CONFIGURATION.path,
        layout: routeConfig.SETTINGS.layout,
        icon: 'settings',
        children: [
          {
            id: 'payment-config',
            name: 'Payment configuration',
            path: routeConfig.SETTINGS.CONFIGURATION.path,
            layout: routeConfig.SETTINGS.layout,
            icon: 'credit-card',
          },
          {
            id: 'system-config',
            name: 'System configurations',
            path: routeConfig.SETTINGS.LOCATION_CONFIG.path,
            layout: routeConfig.SETTINGS.layout,
            icon: 'command',
          },
          {
            id: 'internal-config',
            name: 'Internal Configuration',
            path: routeConfig.SETTINGS.INTERNAL_CONFIGURATION.path,
            layout: routeConfig.SETTINGS.layout,
            requiredPermissions: [
              'msotreezpay::admin',
              'msotreezpay::readAdminEntityProcessorConfiguration',
            ],
            icon: 'lock',
          },
        ],
      },
    ],
  },
];

export function getSectionsForUserType(userType: UserType): SidebarSection[] {
  switch (userType) {
    case 'partner':
      return partnerSections;
    case 'dispensary':
      return dispensarySections;
    default:
      return dispensarySections;
  }
}
